import script from "./DisabilityGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./DisabilityGuide.vue?vue&type=script&lang=ts&setup=true"

import "./DisabilityGuide.vue?vue&type=style&index=0&id=b4b0cab0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4b0cab0"]])

export default __exports__